<div
  class="invoices background-white scrollable-container table-container"
>
  <div class="filter-and-add" *ngIf="selection.size === 0">
    <div class="invoice-filter">
      <mat-form-field
        [hideRequiredMarker]="true"
        style="height: 48px; width: 230px"
        appearance="outline"
      >
        <mat-label>Search employees</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Search by name, JMBG..."
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="add-invoice">
      <div class="salary-calc-split-btn">
        <button
          class="add-new-button pointer bulk-action"
          (click)="openSalaryCalculation()"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 19 20.1 19 19V5C21 3.9 20.1 3 19 3ZM13.03 7.06L14.09 6L15.5 7.41L16.91 6L17.97 7.06L16.56 8.47L17.97 9.88L16.91 10.94L15.5 9.53L14.09 10.94L13.03 9.88L14.44 8.47L13.03 7.06ZM6.25 7.72H11.25V9.22H6.25V7.72ZM17.5 17H6.5V15.5H17.5V17ZM17.5 14H6.5V12.5H17.5V14Z" fill="#5E5E70"/>
          </svg>
          &nbsp;Obračun plaća
        </button>
        <button
          class="add-new-button pointer dropdown-arrow"
          [matMenuTriggerFor]="salaryArchiveMenu"
        >
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">arrow_drop_down</mat-icon>
        </button>
      </div>

      <mat-menu #salaryArchiveMenu="matMenu">
        <button mat-menu-item (click)="openSalaryCalculation()">
          <mat-icon>add</mat-icon>
          <span>Novi obračun</span>
        </button>
        <mat-divider *ngIf="savedPayrolls.length > 0"></mat-divider>
        <div class="menu-section-label" *ngIf="savedPayrolls.length > 0">
          <small style="padding: 8px 16px; color: #797a81; font-weight: 500;">Arhiva obračuna</small>
        </div>
        <button mat-menu-item *ngFor="let payroll of savedPayrolls" (click)="openSalaryCalculation(payroll.id)">
          <mat-icon>description</mat-icon>
          <span>{{ getPayrollLabel(payroll) }}</span>
        </button>
        <button mat-menu-item disabled *ngIf="savedPayrolls.length === 0">
          <span>Nema sačuvanih obračuna</span>
        </button>
      </mat-menu>

      <button
        style="width: 202px"
        class="primary-button"
        (click)="openAddEmployeeDialog()"
      >
        <img src="assets/icons/add.svg" alt="Add Icon">
        &nbsp;
        <span>Add Employee</span>
      </button>
    </div>
  </div>

  <div class="action-bar" *ngIf="selection.size > 0">
    <div style="display: flex; align-items: center; margin-left: 16px">
      <mat-icon
        style="margin-right: 8px; cursor: pointer; font-size: 26px"
        (click)="toggleAllSelection()"
        >close</mat-icon
      >
      <span class="custom-button-selected"
        >{{ selection.size }}
        {{ selection.size === 1 ? "item" : "items" }} selected</span
      >
    </div>
    <div style="display: flex; align-items: center">
      <button class="custom-button" mat-button (click)="toggleAllSelection()">
        {{ isAllSelected() ? 'Unselect all' : 'Select all' }}
      </button>
      <div
        class="icon-wrapper"
        (click)="$event.stopPropagation(); bulkDeleteEmployees()"
        (mouseover)="isHovered = true"
        (mouseleave)="isHovered = false"
      >
        <svg
          width="24" height="18" viewBox="0 0 16 18" fill="none"
          xmlns="http://www.w3.org/2000/svg"
          [style.fill]="isHovered ? '#1E31CF' : '#27272C'"
        >
          <path d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"/>
        </svg>
      </div>
    </div>
  </div>

  <table
    *ngIf="dataSource?.filteredData?.length && !isLoading"
    mat-table
    [dataSource]="dataSource"
    matSort
    class="mt-20 si-table"
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-checkbox
          class="custom-checkbox"
          [checked]="isSelected(element)"
          (change)="toggleSelection(element)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <!-- First Name -->
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">
        <span class="roboto">First Name</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
    </ng-container>

    <!-- Last Name -->
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">
        <span class="roboto">Last Name</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
    </ng-container>

    <!-- Birth Date -->
    <ng-container matColumnDef="birthDate">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">Birth Date</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ formatDate(element.birthDate) }}</td>
    </ng-container>

    <!-- JMBG -->
    <ng-container matColumnDef="jmbg">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">JMBG</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.jmbg || '-' }}</td>
    </ng-container>

    <!-- Address -->
    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">Address</span>
      </th>
      <td mat-cell *matCellDef="let element">
        {{ (element.address | slice:0:20) || '-' }}<span *ngIf="element.address?.length > 20">...</span>
      </td>
    </ng-container>

    <!-- Municipality Code -->
    <ng-container matColumnDef="municipalityCode">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">Mun. Code</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.municipalityCode || '-' }}</td>
    </ng-container>

    <!-- Start Date -->
    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">Start Date</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ formatDate(element.startDate) }}</td>
    </ng-container>

    <!-- End Date -->
    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">End Date</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ formatDate(element.endDate) }}</td>
    </ng-container>

    <!-- Tax Card -->
    <ng-container matColumnDef="taxCard">
      <th mat-header-cell *matHeaderCellDef>
        <span class="roboto">Tax Card</span>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.taxCard || '-' }}</td>
    </ng-container>

    <!-- Gross Salary (Bruto I) -->
    <ng-container matColumnDef="grossSalary">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="grossSalary">
        <span class="roboto">Bruto I</span>
      </th>
      <td mat-cell *matCellDef="let element" style="text-align: right;">
        {{ formatCurrency(element.grossSalary) }}
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="operations triggered" style="display: flex; align-items: center">
          <div
            class="icon-wrapper2"
            (click)="$event.stopPropagation(); openEditEmployeeDialog(element)"
            [style.visibility]="selection.size > 0 ? 'hidden' : 'visible'"
          >
            <div class="svg-container">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.86206 17.125H4.26206L12.8871 8.5L11.4871 7.1L2.86206 15.725V17.125ZM17.1621 7.05L12.9121 2.85L14.3121 1.45C14.6954 1.06667 15.1664 0.875 15.7251 0.875C16.2831 0.875 16.7537 1.06667 17.1371 1.45L18.5371 2.85C18.9204 3.23333 19.1204 3.696 19.1371 4.238C19.1537 4.77933 18.9704 5.24167 18.5871 5.625L17.1621 7.05ZM15.7121 8.525L5.11206 19.125H0.862061V14.875L11.4621 4.275L15.7121 8.525Z"
                  fill="#27272C"
                />
              </svg>
            </div>
          </div>
          <div
            [style.visibility]="selection.size > 0 ? 'hidden' : 'visible'"
            class="icon-wrapper"
            (click)="$event.stopPropagation(); deleteEmployee(element)"
            (mouseover)="isHovered1 = true"
            (mouseleave)="isHovered1 = false"
          >
            <svg
              width="24" height="18" viewBox="0 0 16 18" fill="none"
              xmlns="http://www.w3.org/2000/svg"
              [style.fill]="isHovered1 ? '#1E31CF' : '#27272C'"
            >
              <path d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.196 17.021 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.021 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"/>
            </svg>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="show-on-hover" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <ng-container *ngIf="!isLoading && !dataSource?.filteredData?.length">
    <div class="no-data-wrapper">
      <img width="139px" height="225px" src="/assets/icons/printer.svg" />
      <p class="no-data-title">No employees</p>
      <p>
        Press the button at the top right corner <br />
        to add your first employee.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <table class="si-table">
      <tbody>
        <tr *ngFor="let number of [1, 2, 3, 4, 5]">
          <td>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '15px', width: '150px', 'border-radius': '3px' }">
            </ngx-skeleton-loader>
          </td>
          <td>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '15px', width: '300px', 'border-radius': '3px' }">
            </ngx-skeleton-loader>
          </td>
          <td>
            <ngx-skeleton-loader count="1" appearance="line"
              [theme]="{ height: '15px', width: '70px', 'border-radius': '3px' }">
            </ngx-skeleton-loader>
          </td>
          <td>
            <ngx-skeleton-loader count="1" appearance="circle"></ngx-skeleton-loader>
            <ngx-skeleton-loader count="1" appearance="circle"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
